const Chat = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27 1H5C2.794 1 1 2.794 1 5V11H14.586L10.586 7L12 5.586L18.414 12L12 18.414L10.586 17L14.586 13H1V18C1 20.206 2.794 22 5 22H8V28.869L18.303 22H27C29.206 22 31 20.206 31 18V5C31 2.794 29.206 1 27 1Z"
        fill={color}
      />
    </svg>
  );
};
export default Chat;
